const ChatSvg = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 18.625C2.33424 18.625 2.17527 18.5592 2.05806 18.4419C1.94085 18.3247 1.875 18.1658 1.875 18V4.66667C1.87544 4.05901 2.11702 3.47638 2.5467 3.0467C2.97637 2.61703 3.55901 2.37544 4.16667 2.375H15.8333C16.441 2.37544 17.0236 2.61703 17.4533 3.0467C17.883 3.47638 18.1246 4.05901 18.125 4.66667V13C18.1246 13.6077 17.883 14.1903 17.4533 14.62C17.0236 15.0496 16.441 15.2912 15.8333 15.2917H6.0925L2.94167 18.4417C2.88379 18.4999 2.81497 18.546 2.73917 18.5775C2.66336 18.609 2.58208 18.6251 2.5 18.625ZM4.16667 3.625C3.89053 3.62544 3.62584 3.73533 3.43058 3.93058C3.23533 4.12584 3.12544 4.39053 3.125 4.66667V16.4908L5.39167 14.225C5.44957 14.1668 5.5184 14.1207 5.5942 14.0892C5.66999 14.0578 5.75126 14.0416 5.83333 14.0417H15.8333C16.1095 14.0412 16.3742 13.9313 16.5694 13.7361C16.7647 13.5408 16.8746 13.2761 16.875 13V4.66667C16.8746 4.39053 16.7647 4.12584 16.5694 3.93058C16.3742 3.73533 16.1095 3.62544 15.8333 3.625H4.16667Z"
      fill="currentColor"
    />
  </svg>
);

export default ChatSvg;
